var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('hotel-form',{model:{value:(_vm.hotel),callback:function ($$v) {_vm.hotel=$$v},expression:"hotel"}})}
var staticRenderFns = []

export { render, staticRenderFns }